import { render, staticRenderFns } from "./statsByCity.vue?vue&type=template&id=7879980a&"
import script from "./statsByCity.vue?vue&type=script&lang=js&"
export * from "./statsByCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports